module.exports = __webpack_public_path__ + "static/media/fullstack.03a30a81.svg";